import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MaterialModule } from '../Shared/Material/material.module';
// import { ChartsModule } from 'ng2-charts';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { QueriesRequestsComponent } from './queries-requests/queries-requests.component';
import { Base64Component } from './base64/base64.component';
// import {AccumulationChartModule,AccumulationTooltipService} from "@syncfusion/ej2-angular-charts";
import { NavComponent } from './nav/nav.component';
import { AccumulationChartModule, AccumulationTooltipService } from '@syncfusion/ej2-angular-charts';
// import { PerfectScrollbarModule, PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';


const routes: Routes = [
  { path: '', redirectTo: 'Home', pathMatch: 'full'},
  { path:'Home', component: DashboardComponent },
  { path:'My Profile', component: ProfileComponent },
  { path:'Contact Us', component: ContactUsComponent },
  { path:'Service Request', component: QueriesRequestsComponent},
  { path:'Nav', component: NavComponent}, 
  { path:'base64', component: Base64Component},  
]
// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   wheelPropagation: true
// };
@NgModule({
  declarations: [
    DashboardComponent,
    ProfileComponent,
    ContactUsComponent,
    QueriesRequestsComponent,
    Base64Component,
    NavComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MaterialModule,
    // ChartsModule, 
    FormsModule,
    AccumulationChartModule,
    // PerfectScrollbarModule,
     ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    // },
    AccumulationTooltipService
  ]
})
export class CommonLayoutModule { }
